export const ButtonStyles = {
  
  footerResetBtn: {
    backgroundColor: "#fff",
    border: "1px solid #1D1C3E",
    borderRadius: "21px",
    color: "#1D1C3E", 
    width: "15vw",
    height: "36px",
    cursor: "arrow",
  },
  footerDownloadBtn: {
    backgroundColor: "#1D1C3E",
    // width: "fit-content",
    // color: "#1D1C3E",  //dr dowload button color
    borderRadius: "21px",
    width: "15vw",
    height: "36px",
    // width: "fit-content",
    padding: "0px 5px", 
  },

  p:{
    margin: "1rem 0rem 0rem 1rem",
  }
};

